import React, { useEffect, useState, useRef } from 'react';
import { Carousel } from 'react-bootstrap';

function FruitDetailBanner() {
    const images = [
        '/server-build/Images/resize-1736752773575034845Banner61.png',
        '/server-build/Images/resize-17367549701217847936Banner61.png',
        '/server-build/Images/resize-17367549701217847936Banner61.png',
        '/server-build/Images/resize-17367549701217847936Banner61.png',
        '/server-build/Images/resize-17367549701217847936Banner61.png',
    ];

    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0); 
    const carouselRef = useRef(null);

    useEffect(() => {
        const checkScreenSize = () => {
            const smallScreen = window.innerWidth <= 768;

            
            if (!smallScreen && isSmallScreen) {
                setActiveIndex(0);
            }

            setIsSmallScreen(smallScreen);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, [isSmallScreen]);

    const handleSelect = (selectedIndex) => {
        setActiveIndex(selectedIndex);
    };

    return (
        <div className="row mb-5 detailBanner" style={{ columnGap: '20px' }}>
            <div className="col abc1">
                <Carousel data-bs-theme="dark" interval={isSmallScreen ? 3500 : null} activeIndex={activeIndex} onSelect={handleSelect} ref={carouselRef}>
                    {images.map((src, index) => (
                        <Carousel.Item key={index}>
                            <img className="d-block w-100 img-fluid" style={{ width: '580px', height: '320px' }} src={src} />
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>

            <div className="col d-none d-lg-block">
                <div className="row" style={{ paddingBottom: '10px', columnGap: '18px' }}>
                    {images.slice(0, 2).map((src, colIndex) => (
                        <div key={colIndex} className="col abc2">
                            <img className="img-fluid w-100" style={{ width: '280.94px', height: '155px' }} src={src} />
                        </div>
                    ))}
                </div>
                <div className="row" style={{ columnGap: '18px' }}>
                    {images.slice(2, 4).map((src, colIndex) => (
                        <div key={colIndex} className="col abc2">
                            <img className="img-fluid w-100" style={{ width: '280.94px', height: '155px' }} src={src} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FruitDetailBanner;
